"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteSignalementMutation = exports.useLazySignalementByIdQuery = exports.useGetSignalementsQuery = exports.useAddOrUpdateSignalementMutation = exports.SignalementApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.SignalementApi = (0, react_1.createApi)({
    reducerPath: "signalementApi",
    tagTypes: ["signalement", "signalementList", "signalementById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateSignalement: builder.mutation({
            invalidatesTags: [
                "signalement",
                "signalementList",
                "signalementById",
            ],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `reports/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `reports/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getSignalements: builder.query({
            providesTags: ["signalementList"],
            query: (query) => (0, Utils_1.QueryUrl)("reports", query),
        }),
        signalementById: builder.query({
            query: (id) => `reports/${id}/`,
            providesTags: ["signalementById"],
        }),
        deleteSignalement: builder.mutation({
            query: (id) => ({
                url: `reports/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: [
                "signalement",
                "signalementList",
                "signalementById",
            ],
        }),
    }),
});
exports.useAddOrUpdateSignalementMutation = exports.SignalementApi.useAddOrUpdateSignalementMutation, exports.useGetSignalementsQuery = exports.SignalementApi.useGetSignalementsQuery, exports.useLazySignalementByIdQuery = exports.SignalementApi.useLazySignalementByIdQuery, exports.useDeleteSignalementMutation = exports.SignalementApi.useDeleteSignalementMutation;
